import marketing from '@/shared/api/marketing';

export interface RipplingDemoTimePayload {
  // User data
  Email: string;
  FirstName: string;
  LastName: string;
  Company: string;
  NumberOfEmployees: number;
  Phone: string;
  Country: string;

  // Page tracking
  formFillLandingPage: string;
  Form_Fill_Referring_URL__c: string;

  // Flow state
  demotimeEligible: boolean;
  demotimeLoaded: boolean;
  demotimeClosed: boolean;
  didMeetingAvailabiltyLoad: boolean;

  // Client timezone
  clientTimeZone: string;

  // Stringified events
  demotimeEvents: string;

  // UTM parameters (optional - only present if found in URL)
  LT_Campaign__c?: string;
  LT_Content__c?: string;
  LT_Medium__c?: string;
  LT_Source__c?: string;
  LT_Term__c?: string;

  // System-generated tracking fields
  Form_Type__c: string;
  Landing_Page__c: string;
  formProgress_stage2: string;
  transactionId: string;
  formIdentifier: string;
  Last_Lead_Origin__c: string;
  user_agent: string;

  // Meeting details (only present if booking confirmed)
  ActivityDate?: string;
  ActivityDateTime?: string;
  ActivityDuration?: number;
  ActivityTimeZone?: string;
  EventStartDateTime?: string;
  EventEndDateTime?: string;
  AssigneeEmail?: string;
  AssigneeId?: string;
  EventOwnerId?: string;
  DemotimeMeetingId?: string;
  Queue_Name_CP__c?: string;
  Router_Name_CP__c?: string;
  dt_Meeting_Datetime_In_Prospect_Time_Zone?: string;
  dt_Meeting_Datetime_String_In_Prospect_Time_Zone?: string;

  // Openprise flag (only present in non-production environments)
  OpenpriseEnabled?: boolean;
}

export interface RipplingPayloadWrapper {
  data: RipplingDemoTimePayload;
}

export async function sendRipplingDemoTimeEvent(payload: RipplingPayloadWrapper): Promise<void> {
  try {
    await marketing.url('/rippling-demo').post(payload);
  } catch (error) {
    console.error('Failed to send Rippling DemoTime payload:', error);
  }
}
